module.exports = __webpack_public_path__ + "img/product_96.7fdbc38.webp";